import { createAction } from '@reduxjs/toolkit';

/** «Ver de dónde sale»: the visit moves to its sources while the plan is asked. Sent by a thunk, hence apart. */
export const kitSourcesShown = createAction('operatorKits/sourcesShown');
